import { Card } from '@ordo/ui/card'

import { Badge } from '@/components/chefs/badge'
import { ListGroupHeader } from '@/components/chefs/list-group-header'
import { type CampusSupplyRow, visibleSupplyLines } from '@/lib/chefs/service-materials'
import type { SupplyLine } from '@/lib/chefs/types'

import { CHEF_SERVICE_MATERIALS_VISIBLE } from '../../../../shared/chef-packaging-visibility'

/** Final pull list. Ingredients also includes food containers; other views show bags and supplies. */
export function SuppliesTable({
  rows,
  includePackaging = false,
  embedded = false,
  className,
}: {
  rows: ReadonlyArray<SupplyLine | CampusSupplyRow>
  includePackaging?: boolean
  /** Use inside the Ingredients list's existing border. */
  embedded?: boolean
  className?: string
}) {
  const visibleRows = visibleSupplyLines(rows, includePackaging)
  if (!CHEF_SERVICE_MATERIALS_VISIBLE || visibleRows.length === 0) {
    return null
  }
  const section = (
    <section aria-label="Supplies">
      <ListGroupHeader label="Supplies" count={visibleRows.length} />
      <div className="divide-y divide-border">
        {visibleRows.map((row) => (
          <div
            key={JSON.stringify([row.skuId, row.isCompostable])}
            className="flex items-center gap-3 px-4 py-2.5 text-sm lg:px-6">
            <span className="w-24 shrink-0 font-semibold tabular-nums text-foreground">
              {row.qty.toLocaleString()}x
            </span>
            <span className="min-w-0 flex-1 text-foreground">{row.name}</span>
            {row.isCompostable ? <Badge variant="compostable">Compostable</Badge> : null}
          </div>
        ))}
      </div>
    </section>
  )
  return embedded ? (
    section
  ) : (
    <Card className={`overflow-hidden rounded-2xl border-border bg-background py-0 shadow-xs ${className ?? ''}`}>
      {section}
    </Card>
  )
}
